"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FEDERAL_RULES = void 0;
const saaThresholds_1 = require("encamp-shared/dist/constants/saaThresholds");
exports.FEDERAL_RULES = [
    {
        id: "FED_CENTRAL_LQG",
        scope: "FEDERAL",
        areaType: "CENTRAL",
        generatorStatus: "LQG",
        limit: { kind: "TIME", days: 90 },
        citation: "40 CFR 262.17(a)",
    },
    {
        id: "FED_CENTRAL_SQG",
        scope: "FEDERAL",
        areaType: "CENTRAL",
        generatorStatus: "SQG",
        limit: { kind: "TIME", days: 180 },
        citation: "40 CFR 262.16(b)",
        // The 200-mile exception (below) supersedes this default when it applies.
        condition: (ctx) => !ctx.sqgOver200Miles,
    },
    {
        id: "FED_CENTRAL_SQG_200MI",
        scope: "FEDERAL",
        areaType: "CENTRAL",
        generatorStatus: "SQG",
        limit: { kind: "TIME", days: 270 },
        citation: "40 CFR 262.16(d)",
        condition: (ctx) => ctx.sqgOver200Miles,
    },
    // VSQGs have no federal central accumulation-area clock (40 CFR 262.14) —
    // intentionally no rule here for (VSQG, CENTRAL).
    {
        id: "FED_SATELLITE",
        scope: "FEDERAL",
        areaType: "SATELLITE",
        generatorStatus: "ANY",
        limit: {
            kind: "VOLUME",
            nonAcuteGal: saaThresholds_1.SAA_NON_ACUTE_VOLUME_LIMIT_GAL,
            acuteGal: saaThresholds_1.SAA_ACUTE_VOLUME_LIMIT_GAL,
            acuteKg: saaThresholds_1.SAA_ACUTE_MASS_LIMIT_KG,
            moveWindowDays: saaThresholds_1.SATELLITE_MOVE_WINDOW_DAYS,
        },
        citation: "40 CFR 262.15",
        // Doesn't apply to VSQGs. 262.15 is written as an exemption from the
        // central-accumulation rules in 262.16 (SQG) and 262.17 (LQG), so a
        // satellite area is relief from time limits a VSQG never had in the
        // first place. VSQGs are governed by 262.14, which never refers to
        // 262.15. What actually constrains them is the facility-wide 1,000 kg
        // on-site cap, which the facility rollup handles, not this rule.
        //
        // This reading of the regulation has not been confirmed by a regulatory
        // specialist yet.
        //
        // A facility whose generator status is unknown (null) still gets these
        // limits — the safer default until we know its status.
        //
        // Two cases could put a VSQG back under these caps, and neither can be
        // expressed here today: a state may impose satellite-area limits that
        // federal law doesn't, and a VSQG that exceeds its monthly or on-site
        // limits temporarily takes on SQG or LQG rules for that period — which a
        // generator status covering a whole year can't represent.
        condition: (ctx) => ctx.generatorStatus !== "VSQG",
    },
];
//# sourceMappingURL=federal.js.map